<template>
	<v-dialog v-model="dialog" :max-width="520" persistent>
		<div class="relative bg-white rounded pt-5 pb-6">
			<AppLogo class="mx-auto mb-5" />

			<div class="px-5 d-flex justify-center">
        <div
          v-if="!Array.isArray(popupContent)"
          class="popup-content"
        >
          {{ popupContent }}
        </div>
				<ul class="ul-1" v-else>
					<li v-for="(val, key) in popupContent" :key="key">
						{{ val }}
					</li>
				</ul>
			</div>

			<div class="text-center mt-4">
				<v-btn
					class="text-white"
					color="primary"
					elevation="0"
					@click="onClose"
					style="min-width: 120px">
					Ok
				</v-btn>
			</div>
		</div>
	</v-dialog>
</template>
<script>
import { useNotificationStore } from '@/stores/notification';
import AppLogo from '@/components/MainLogo.vue';

export default {
  name: 'GlobalMessageModal',
	components: {
		/**
		 * You must import the global component,
		 * otherwise it will be failed.
		 * https://vuejs.org/guide/extras/web-components#using-custom-elements-in-vue
		 */
		 AppLogo
	},
  data () {
    return {
      dialog: false
    }
  },
	computed: {
		appNotifyStore () {
			return useNotificationStore()
		},
    message () {
      return this.appNotifyStore.getMessage
    },
    hasErrorFromServer () {
      return this.appNotifyStore.hasErrorFromServer
    },
    popupContent () {
      if (this.message?.constructor !== Object) return this.message;
			return this.getContent(this.message);
    },
	},
  watch: {
    message (val) {
      this.dialog = !!val;
    }
  },
	methods: {
    onClose () {
			this.dialog = false;

      setTimeout(() => {
				this.appNotifyStore.setMessage();
			}, 800)
    },
    getContent (message = {}) {
			if (!this.hasErrorFromServer) return message;

			// bug 500, 404, or undefined bugs from the serser
			const messageData =  message.data?.errors;
			if (
				!Object.keys(messageData || {}).length ||
				message.status === 500
			) {
				return message.data?.message || message.data || message;
			}

      /**
			 * Error response format
			 * from server (may be changed):
			 * message = {
			 *  data: {
			 *   errors: {...}
			 *  },...
			 * }
			 */
			message.errors = JSON.parse(JSON.stringify(messageData));

      const messageArr = [];
      for (const key in message.errors) {
        messageArr.push( message.errors[key])
      }

      return [...messageArr];
    }
	},
};
</script>
<style lang="scss" scoped>
.ul-1 {
	list-style-type: none;
	li {
		&:not(:last-child) { margin-bottom: 12px; }
	}
}
.popup-content {
  max-height: 380px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
